import Header from "../../common/Header";
import ScrollButton from "../scrollButton";
import { MainWrapper } from "../../common/MainWrapper";
import { BackToPanel } from "../../common/BackToPanel";
import { TableWrapper, LinkDelete, LinkShow, StyledMainTitle } from "../styled";
import { useAllInvoices } from "../../common/useAllInvoices";
import moment from "moment/moment";
import { baseUrl } from "../../common/apiUrl";
import axios from "axios";
import { useState } from "react";

const InvoicesList = ({ user }) => {
  
  const item = useAllInvoices();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const deleteAndRefresh = (id) => {
    if (
      window.confirm(
        `Are you sure to delete Invoice number?`)) {
      deleteInvoice(id);
    }
  };

  
  const deleteInvoice = (id) => {
    axios
      .delete(`${baseUrl}/deleteInvoice.php`, {
        data: { id: id },
      })
      .then(() => {
        reload();
       
      })
      .catch(() => {
        alert("Error in the Code");
      });
  };

  const reload = () => {
    window.location.reload();
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = item.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Generate page numbers
  const pageNumbers = [];
  const totalPages = Math.ceil(item.length / itemsPerPage);
  const maxVisiblePages = 3;
  let startPage, endPage;

  if (totalPages <= maxVisiblePages) {
    // Display all pages if total pages are less than or equal to max visible pages
    startPage = 1;
    endPage = totalPages;
  } else {
    // Calculate start and end page to limit the number of visible pages
    const maxVisiblePagesBeforeCurrent = Math.floor(maxVisiblePages / 2);
    const maxVisiblePagesAfterCurrent = Math.ceil(maxVisiblePages / 2) - 1;

    if (currentPage <= maxVisiblePagesBeforeCurrent) {
      // Current page is near the start
      startPage = 1;
      endPage = maxVisiblePages;
    } else if (currentPage + maxVisiblePagesAfterCurrent >= totalPages) {
      // Current page is near the end
      startPage = totalPages - maxVisiblePages + 1;
      endPage = totalPages;
    } else {
      // Current page is in the middle
      startPage = currentPage - maxVisiblePagesBeforeCurrent;
      endPage = currentPage + maxVisiblePagesAfterCurrent;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <Header user={user} />
      <ScrollButton />
      <MainWrapper>
        <StyledMainTitle>List All Invoices </StyledMainTitle>

        <BackToPanel />

        <TableWrapper>
          <table className="table table-dark table-striped table-bordered table-modified">
            <thead>
              <tr>
                <td>#</td>
                <td>Issue Date</td>
                <td>
                  Invoice
                  <br />
                  Number
                </td>
                <td>
                  Netto
                  <br />
                  Amount
                </td>
                <td>
                  Bonus
                  <br />
                  Amount
                </td>
                <td>
                  Delete
                  <br />
                  Invoice
                </td>
                <td>
                  Show
                  <br />
                  Invoice
                </td>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item, index) => {
                const FormattedIssueDate = moment(item.invoiceDate)
                  .locale("en-gb")
                  .format("DD-MM-YYYY");

                return (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{FormattedIssueDate}</td>
                    <td>FVS {item.invoiceNumber}</td>
                    <td>{item.totalErnNetto} PLN</td>
                    <td>{item.bonusAmount}</td>

                    <td>
                      <LinkDelete
                        to=""
                        onClick={() => deleteAndRefresh(item.id)}
                      >
                        Delete
                      </LinkDelete>
                    </td>

                    <td>
                      <LinkShow to={`/invoice/${item.id}`}>
                        Show Invoice
                      </LinkShow>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </TableWrapper>
        <nav>
          <ul className="pagination justify-content-center">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
              >
                First
              </button>
            </li>
            {currentPage > 1 && (
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage - 1)}
                >
                  Previous
                </button>
              </li>
            )}
            {pageNumbers.map((pageNumber) => (
              <li
                key={pageNumber}
                className={`page-item ${
                  pageNumber === currentPage ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => paginate(pageNumber)}
                >
                  {pageNumber}
                </button>
              </li>
            ))}
            {currentPage < totalPages && (
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            )}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
              >
                Last
              </button>
            </li>
          </ul>
        </nav>
      </MainWrapper>
    </>
  );
 
}
export default InvoicesList;